const commerceApiUrl = String(
  import.meta.env.VITE_COMMERCE_API_URL || "http://127.0.0.1:8791"
).replace(/\/$/, "");

async function getCustomerOrderData(
  storeSlug,
  sessionToken,
  suffix,
  { signal, invalidResponse } = {}
) {
  const basePath = `/v1/storefront/stores/${encodeURIComponent(
    storeSlug
  )}/customer/orders`;
  const response = await fetch(`${commerceApiUrl}${basePath}${suffix}`, {
    method: "GET",
    headers: {
      Accept: "application/json",
      Authorization: `Bearer ${sessionToken}`,
    },
    signal,
  });
  const result = await response.json().catch(() => null);

  if (!response.ok) {
    const error = new Error(
      result?.error || "Não foi possível carregar seus pedidos."
    );
    error.status = response.status;
    error.code = result?.code;
    throw error;
  }
  if (!result?.data || (invalidResponse && invalidResponse(result.data))) {
    throw new Error("A loja retornou dados de pedido inválidos.");
  }

  return result.data;
}

export function fetchCustomerOrders(
  storeSlug,
  sessionToken,
  { signal } = {}
) {
  return getCustomerOrderData(storeSlug, sessionToken, "", {
    signal,
    invalidResponse: (data) => !Array.isArray(data.orders),
  });
}

export function fetchCustomerOrder(
  storeSlug,
  orderId,
  sessionToken,
  { signal } = {}
) {
  return getCustomerOrderData(
    storeSlug,
    sessionToken,
    `/${encodeURIComponent(orderId)}`,
    {
      signal,
      invalidResponse: (data) => !data.id || !Array.isArray(data.items),
    }
  );
}
